import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { FetchPostParams, IPostModel } from '../../models';
import { postService } from '../../services/post.service';
import { LocalStorageService } from '../../configuration';

interface JwtPayload {
  Role?: string[];
  // ...other fields if needed
}

export const usePostHook = ({ pageNumber }: { pageNumber: number }) => {
  const [posts, setPosts] = useState<IPostModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(false);

  // Get roles from JWT in localStorage
  let roles: string[] | undefined;
  const token = LocalStorageService.getItem('accessToken');
  if (token) {
    try {
      const decoded = jwtDecode<JwtPayload>(token);
      roles = decoded.Role;
    } catch {
      roles = undefined;
    }
  }
  const appendNewPost = (newPost: IPostModel) => {
    setPosts((prev) => [newPost, ...prev]);
  };

  const getPosts = async (payload: FetchPostParams) => {
    try {
      setLoading(true);
      let data;
      let hasMore;
      // If roles is undefined or empty, call public API
      if (!roles || roles.length === 0) {
        ({ data, hasMore } = await postService.getPublicPosts(payload));
      } else {
        ({ data, hasMore } = await postService.getPosts(payload));
      }
      setPosts((prev) => [...prev, ...data]);
      setHasMore(hasMore);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPosts({
      pageNumber,
      pageSize: 10,
    });
  }, [pageNumber]);

  return {
    data: posts,
    loading,
    hasMore,
    appendNewPost,
  };
};
